export default __webpack_public_path__ + "static/media/reset-icon.d7cfc190.svg";